// Safely get initial state from localStorage
const getInitialState = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      const parsedData = JSON.parse(data);
      return (Array.isArray(parsedData) && parsedData.length > 0) ? parsedData[0] : 0;
    }
    return 0;
  } catch (error) {
    console.warn(`Failed to parse ${key} from localStorage:`, error);
    return 0;
  }
};

let initialState = getInitialState("teamlistData");

const teamlistData = (state = initialState, action) => {

    switch(action.type){ 
      case "TEAMLIST" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default teamlistData